// theme.js ships a second, unguarded cross-sell carousel initializer
// (loadCrossSellProducts, wired to DOMContentLoaded) left over from an
// earlier change. It duplicates/races the cart drawer's own Flickity
// init in sections/cart-drawer.liquid, which already re-inits safely
// (destroys any existing instance first) on cart reload/drawer open.
// Two uncoordinated initializers on the same element is what caused
// the cart drawer's "You may also like" carousel to render correctly
// sometimes and with broken spacing/no arrows other times, depending
// on which one ran last. Neutralize theme.js's copy so the drawer's
// own guarded version is the only one that ever runs.
//
// Must load as a real deferred external script (src=, not inline) so it
// executes after theme.js has defined the original function but before
// DOMContentLoaded fires the listener that calls it. defer has no effect
// on inline scripts, so an inline <script defer> here would run too
// early and get overwritten when theme.js's own deferred script runs.
window.loadCrossSellProducts = function () {};
